
import { Injectable } from "@angular/core";
import { CgpTabbedFormDialogComponent } from "./cgp-tabbed-form-dialog.component";

import { DialogService } from '@progress/kendo-angular-dialog';

const defaults = {
    size: null,
    title: '',
    closeLabel: '',
    onCloseClick: null,
    onClosed: null
};

@Injectable()
export class CgpTabbedFormDialogService {
    constructor(private dialogService: DialogService) { }

    public result;

    show(opts) {
        let options = {
            ...defaults,
            ...opts
        };

        const dialogRef = this.dialogService.open({
            title: options.title,
            content: CgpTabbedFormDialogComponent,

            actions: [
                { text: "Cancel" },
                { text: "Delete", primary: true }
            ]
        });

        const instance = dialogRef.content.instance;
        instance.isNew = options.isNew;
        instance.title = options.title;
        instance.formGroup = options.formGroup;
        instance.formControls = options.formControls;
        instance.tabs = options.tabs;
        instance.model = options.editDataItem;
        instance.cancel = options.close;
        instance.save = options.save;
    }
}
